import {
  CardContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React, { useState} from "react";

import { useLocation } from "react-router-dom";
import GoBack from "../../components/GoBack";
function ViewEnterpise() {
  const { navigationData } = useLocation().state;
  const [responseData, setResponseData] = useState(navigationData);
  // Get the current date and time


  return (
    <div>
      <div className="container">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <h2 className="component-title">Enterprise</h2>
       <GoBack/>
        </div>
    
        <div>
          <div variant="outlined" className="custom-card">
            <CardContent>
              <div className="card-header">
                <div className="card-sub-header">
                  <p>
                    Enterprise name :{" "}
                    <span className="sub-text">
                      {responseData?.name || "N/A"}
                    </span>
                  </p>

                </div>
              </div>
              <TableContainer
                component={Paper}
                className="custom-table-container"
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell>Nature of dispute</TableCell>
                      <TableCell>
                        <span className="sub-text">
                          {responseData?.natureOfDispute || "N/A"}
                        </span>
                      </TableCell>
                      <TableCell className="column-border">
                        Complexity
                      </TableCell>
                      <TableCell>
                        <span className="sub-text">
                          {responseData?.complexity || "N/A"}
                        </span>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="column-border">
                        Created by{" "}
                      </TableCell>
                      <TableCell>
                        <span className="sub-text">
                            {responseData?.createdBy || "N/A"}
                        </span>
                      </TableCell>
                      <TableCell className="column-border">
                        Created at
                      </TableCell>
                      <TableCell>
                        <span className="sub-text"> {responseData?.createdAt || "N/A"}</span>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewEnterpise;
